import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import OperativeDataForm from './OperativeDataForm'
import RouteMoves from '../RouteMoves'

@withGraphQL(gql`
  query getPreparation($preparationId: ID) {
    getPreparation(preparationId: $preparationId) {
      _id
      preparationName
      operativeDataFields {
        value
        name
        validation
        type
        maxLength
      }
      operativeDataFieldsNames
      operativeDataFieldsValues
    }
  }
`)
export default class SSOperativeData extends React.Component {
  static propTypes = {
    getPreparation: PropTypes.object
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.routes}>
          <RouteMoves docId={this.props.getPreparation._id} />
        </div>
        <div className="section">
          <div className="header">
            Registro datos operativos - Documento (<b>
              {this.props.getPreparation.preparationName}
            </b>)
          </div>
          <OperativeDataForm getPreparation={this.props.getPreparation} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSOperativeData/index.js